/**
 * Componente de lista de classificações
 */

import React from 'react';
import { Grid, Box } from '@mui/material';
import { ClassificacaoCard } from './ClassificacaoCard';
import { EmptyState } from '@components/common';
import { Category } from '@mui/icons-material';
import { Classificacao } from '@types';

interface ListaClassificacaoProps {
  classificacoes: Classificacao[];
  onSelectClassificacao: (classificacao: Classificacao) => void;
  isSearching?: boolean;
}

export const ListaClassificacao: React.FC<ListaClassificacaoProps> = ({
  classificacoes,
  onSelectClassificacao,
  isSearching = false,
}) => {
  if (classificacoes.length === 0) {
    return (
      <EmptyState
        title={isSearching ? 'Nenhuma categoria encontrada' : 'Nenhuma categoria disponível'}
        message={
          isSearching
            ? 'Tente ajustar sua busca'
            : 'Não há categorias cadastradas no momento'
        }
        icon={<Category />}
      />
    );
  }

  return (
    <Box>
      <Grid container spacing={2}>
        {classificacoes.map((classificacao) => (
          <Grid item xs={12} key={classificacao.codigo}>
            <ClassificacaoCard
              classificacao={classificacao}
              onClick={onSelectClassificacao}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};